// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"28f27427","796":"95e4b369"}[chunkId] + ".chunk.js";
};